import React from "react";
import Contain from "../contain";
import Title from "../title";

import { Faq, Details, Summary, Img } from "./styles";

export default props => {
  return (
    <Faq>
      <Contain extraSmall zIndex9>
        <Img
          src="https://quickpage-assets.s3.amazonaws.com/public/marketing/bg-faq.svg"
          alt=""
        />

        <Title textCenter>Quickpage FAQ’s</Title>

        <Details open>
          <Summary>
            Do my customers need to have the Quickpage app to view my videos?
          </Summary>

          <p>
            Nope. Your customer will be able to view your video message on any
            smartphone, tablet or computer, no special software required.
          </p>
        </Details>

        <Details>
          <Summary>Do I have to sign a lengthy contract?</Summary>

          <p>Nope, on the monthly plan you cancel at any time.</p>
        </Details>

        <Details>
          <Summary>CRM</Summary>

          <p>
            YES. Keep your CRM. We've designed Quickpage in a way that allows
            you to use our app alongside your CRM and we will show you how.{" "}
          </p>
        </Details>

        <Details>
          <Summary>
            Why can’t I just send a video through text, for free? Or send my
            customer a YouTube link?
          </Summary>

          <p>
            Most times, videos files are too large to send via text and email.
            Have you ever seen what a video looks like sent from an iPhone to an
            android or vise versa? It looks pretty bad and first impressions
            count. You also have no way of knowing when they open and watch that
            video. <br />
            <br />
            What about just sending a YouTube link? There is no bigger
            distraction than YouTube and no better place to send your customer
            if you want them to see your competitor! You may be able to see
            video views but you won’t know WHEN they are watching or who is
            watching. With Quickpage, not only can you attach helpful YouTube
            videos (and images and testimonial videos and pdfs) you can track
            all of your customer’s activities including how many times they have
            viewed, how long, and more. These are critical metrics for every
            sales person to know!
          </p>
        </Details>

        <Details>
          <Summary>
            How long does it take to learn how to use Quickpage?
          </Summary>

          <p>
            The average learning curve is about 5 minutes. You can make and send
            a video in as little as 1 minute.{" "}
          </p>
        </Details>

        <Details>
          <Summary>Will I know when my video has been viewed?</Summary>

          <p>
            YES. The moment your customer opens your video you will get a
            notification. You will be able to see when they are live on the
            page, so that you can make yourself available to answer any of their
            questions in the live chat.
          </p>
        </Details>

        <Details>
          <Summary>
            What is the value of having a team versus an individual account?
          </Summary>

          <p>
            <strong>TRANSPARENCY</strong>: Admins and Managers have access to a
            performance dashboard and can see all of the videos being made by
            their team, communications with leads and even follow up with
            customers on their behalf. <br />
            <br />
            <strong>TEAM PERFORMANCE MANAGER</strong>: A dedicated performance
            manager will live inside of your team and be available for support,
            training and team motivation. <br />
            <br />
            <strong>SHARED FOLDERS</strong>: Team members can share media
            folders. Say for example you make a folder for each model of car
            with images, video walk arounds and related YouTube videos- you can
            instantly share this media with your team. This allows the entire
            team to leverage all work and makes building a page even faster.
            <br />
            <br />
            <strong>SHARED MESSAGES</strong>: Team Members can share canned
            messages. If you have a script that is working with customers, you
            can share it with the entire team.
          </p>
        </Details>

        <Details>
          <Summary>What kind of support and training do you offer?</Summary>

          <p>
            We offer high touch 1 on 1 support accessible through Quickpage app
            for individuals and teams. Teams have a dedicated performance
            manager that lives within their account. In addition, all
            subscribers get access to our exclusive Facebook for Members only
            group where you will get access to community support, tips and
            techniques from sales leaders across multiple industries, live
            webinars and giveaways.{" "}
          </p>
        </Details>
      </Contain>
    </Faq>
  );
};
